import { Action, RootState } from "./store.types";
import { combineReducers } from "redux";

import authReducer from "./modules/auth";
import searchReducer from "./modules/search";
import favouriteUrlReducer from "./modules/favourite-url";
import reportReducer from "./modules/report";
import practiceReducer from "./modules/practice";
import socialReducer from "./modules/social/social.reducer";
import urlReducer from "./modules/url/url.reducer";
import domainReducer from "./modules/domain/domain.reducer";
import facebookUserReducer from "./modules/facebook-user/facebook-user.reducer";
import productReducer from "./modules/product/product.reducer";
import transactionReducer from "./modules/transaction/transaction.reducer";

export default combineReducers<RootState, Action>({
  auth: authReducer,
  search: searchReducer,
  favouriteUrl: favouriteUrlReducer,
  report: reportReducer,
  practice: practiceReducer,
  social: socialReducer,
  url: urlReducer,
  domain: domainReducer,
  facebookUser: facebookUserReducer,
  product: productReducer,
  transaction: transactionReducer,
});
